// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__iTJTe","title":"WelcomeBanner_title__DY57V","appEntry":"WelcomeBanner_appEntry__DUKPZ","appGrid":"WelcomeBanner_appGrid__XLlcE"};